import {
  GET_PAGED_ARTICLES,
  GET_FEATURED_ARTICLE,
  GET_SUGGESTED_ARTICLES,
  UPDATE_FEATURED_ARTICLE,
  UPDATE_SELECTED_ARTICLE,
  UPDATE_ARTICLES,
  SELECT_ARTICLE,
  GET_ARTICLE_BY_ID,
} from '../actions/ArticlesActions';

const initialState = {
  articles: {
    featured: {},
    list: {},
    suggested: {},
  },
  selectedArticle: {},
  articleById: {},
};

export default function articlesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PAGED_ARTICLES:
      return {
        ...state,
        //articles: action.data,
        articles: {
          ...state.articles,
          list: action.data,
        },
      };
    case GET_FEATURED_ARTICLE:
      return {
        ...state,
        //featuredArticle: action.data,
        articles: {
          ...state.articles,
          featured: action.data,
        },
      };
    case GET_SUGGESTED_ARTICLES:
      return {
        ...state,
        //featuredArticle: action.data,
        articles: {
          ...state.articles,
          suggested: action.data,
        },
      };
    case UPDATE_FEATURED_ARTICLE:
      return {
        ...state,
        articles: {
          ...state.articles,
          featured: action.data,
        },
      };
    case UPDATE_SELECTED_ARTICLE:
      return {
        ...state,
        selectedArticle: action.data,
      };
    case UPDATE_ARTICLES:
      return {
        ...state,
        articles: action.data,
      };
    case SELECT_ARTICLE:
      return {
        ...state,
        selectedArticle: action.data,
      };
      case GET_ARTICLE_BY_ID:
        return {
          ...state,
          selectedArticle: action.data,
        };
    default:
      return state;
  }
}
